import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CookieService } from '@shopping-angular-components/common-library';
import { Promotion } from 'src/app/models/promotion';
import { PromotionType } from 'src/app/shared/models/promotion-type';
import { EvaSize } from 'src/app/shared/types/eva.type';
import { CROSS_SELLING_COUPON_COOKIE_NAME } from 'src/app/utils/constants/constants';
import { StaticValuesUtils } from 'src/app/utils/static-values/static-values.utils';

@Component({
  selector: 'promotion-label',
  templateUrl: './promotion-label.component.html',
  styleUrls: ['./promotion-label.component.scss']
})
export class PromotionLabelComponent implements OnInit, OnChanges {
  @Input() promotion: Promotion;
  @Input() position?: string = '-top-left';
  @Input() size?: EvaSize = EvaSize.Medium;

  isOneLoyaltyEnabled: boolean;
  backgroundColor: string;
  text: string;

  private readonly BackgroundColors = {
    PIG_DEAL: '-green',
    DISCOUNT: '-green',
    OFFER: '-green',
  };

  constructor(private cookieService: CookieService) {}

  ngOnInit(): void {
    // si es pig deal, y la cookie de cross selling esta activa, se pinta todo con el cupon
    if (StaticValuesUtils.getIsPigDeal() && this.cookieService.get(CROSS_SELLING_COUPON_COOKIE_NAME) === 'true') {
      this.promotion.type = PromotionType.PIG_DEAL;
    }
    this.isOneLoyaltyEnabled = StaticValuesUtils.isLoyaltyEnabled();
    this.setLabelProperties();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['promotion']) {
      this.text = this.getTextFromDiscountType(this.promotion.type);
      this.setLabelProperties();
    }
  }

  isPigDeal(): boolean {
    return this.promotion.type === PromotionType.PIG_DEAL;
  }

  private isDiscount(): boolean {
    return this.promotion.type === PromotionType.DISCOUNT;
  }

  private isOffer(): boolean {
    return this.promotion.type === PromotionType.OFFER;
  }

  private getTextFromDiscountType(type: string): string {
    switch (type) {
      case PromotionType.OFFER:
      case PromotionType.PIG_DEAL:
      case PromotionType.DISCOUNT:
        return `${this.promotion.percentage}%`;
      default:
        return '';
    }
  }

  private setLabelProperties(): void {
    switch (true) {
      case this.isPigDeal():
        this.backgroundColor = this.BackgroundColors.PIG_DEAL;
        break;
      case this.isDiscount():
        this.backgroundColor = this.BackgroundColors.DISCOUNT;
        break;
      case this.isOffer():
        this.backgroundColor = this.BackgroundColors.OFFER;
        break;
      default:
        this.backgroundColor = this.BackgroundColors.DISCOUNT;
    }
  }
}
